export default {
  getMoedas(state) {
    return state.moedas;
  },
  getCotacoes(state) {
    return state.cotacao;
  },
  getTipoMoedas(state) {
    return state.tiposMoedas;
  },
  getValorCotacao(state) {
    return (value) => {
      // Se oferecer uma moeda diferente, vai usar dólar como padrão
      const moeda = (value === 'USD' || value === 'EUR') ? value : 'USD';

      return state.cotacao[moeda].cotacao;
    };
  },
};
